import { render, staticRenderFns } from "./ModalFullPicture.vue?vue&type=template&id=48f9b098&scoped=true&"
import script from "./ModalFullPicture.vue?vue&type=script&lang=js&"
export * from "./ModalFullPicture.vue?vue&type=script&lang=js&"
import style0 from "./ModalFullPicture.vue?vue&type=style&index=0&id=48f9b098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9b098",
  null
  
)

export default component.exports